var _root;
const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusculoskeletalDigitalTriage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _root || (_root = /*#__PURE__*/React.createElement("root", null));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusculoskeletalDigitalTriage);
export default __webpack_public_path__ + "static/media/musculoskeletal_digital_triage.7c9484477dbd2efcbbd7bc39e85c43b3.svg";
export { ForwardRef as ReactComponent };